/* hk-klaviyo-v1 (v2.5, 28 Sep 2026): the site's email features, straight to Klaviyo.
   Loaded only when Theme settings > HomeKind launch switches > Email features is on.

   Klaviyo Client API from the browser with the public site key (company_id) only;
   no private key is ever on the page.
   - subscribe(): POST /client/subscriptions adds the email to the Email List with email
     marketing consent (SMS consent only when the SMS box was ticked), custom_source per
     form. Then POST /client/profiles sets the properties the welcome flow reads
     (hk_quiz, hk_entry, hk_offer_arm) as a second call, so a property problem can never
     lose the sign up.
   - bis(): POST /client/back-in-stock-subscriptions for one Shopify variant.
   - refill(): the product page refill reminder tick box. The cart attribute
     "Refill reminder" (and "Remind in", 1 to 4 months) is written by hkv2-pages.js; here,
     with a known email, the profile gets hk_refill_opt_in, hk_last_scent, hk_refill_pack
     and hk_refill_months. The event "HK Refill reminder chosen" is sent by the referral
     service from the paid order, not from here (v2.6). With no email yet the choice is
     kept in this browser and added to the profile the next time she signs up here.
   Forms handled here: form[data-hk-kl] (chart bands, shop helper) and form[data-hk-bis].
   The welcome pop up is driven by hkv2-pages.js through window.HKKL.
   If Klaviyo refuses a sign up, the form falls back to its normal Shopify post.
   ES5, guarded. */
(function () {
  "use strict";
  if (window.HKKL || !window.fetch || !window.Promise) return;
  var C = window.HKKL_CFG || {};
  var CO = C.co, LIST = C.list, REV = C.rev || "2025-07-15", PDF = C.pdf || "";
  if (!CO) return;
  var BASE = "https://a.klaviyo.com/client/";
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} return null; }
  function post(path, data) {
    return fetch(BASE + path + "/?company_id=" + encodeURIComponent(CO), {
      method: "POST", mode: "cors", credentials: "omit",
      headers: { "Content-Type": "application/vnd.api+json", Accept: "application/vnd.api+json", revision: REV },
      body: JSON.stringify({ data: data })
    }).then(function (r) {
      if (r.status >= 200 && r.status < 300) return true;
      return r.text().then(function (t) { var e = new Error("Klaviyo " + r.status); e.status = r.status; e.body = t; throw e; });
    });
  }
  function okEmail(s) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(s || "").trim()); }
  /* Australian mobiles to E.164: 04xx xxx xxx, 4xx xxx xxx, +61 4xx... */
  function auMobile(s) {
    var d = String(s || "").replace(/[^\d+]/g, "");
    if (/^\+614\d{8}$/.test(d)) return d;
    if (/^614\d{8}$/.test(d)) return "+" + d;
    if (/^04\d{8}$/.test(d)) return "+61" + d.slice(1);
    if (/^4\d{8}$/.test(d)) return "+61" + d;
    return null;
  }
  function knownEmail() { return C.em || ls("hk_em") || ""; }
  function pendingRefill() { try { return JSON.parse(ls("hk_refill") || "null"); } catch (e) { return null; } }
  function clean(o) { var r = {}; for (var k in o) if (o.hasOwnProperty(k) && o[k] !== undefined && o[k] !== null && o[k] !== "") r[k] = o[k]; return r; }
  /* let Klaviyo's own onsite script (app embed) know who this is, for browse and cart flows */
  function kid(email) { try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (e) {} }
  function remember(email) { ls("hk_em", email); kid(email); }

  function identify(email, props) {
    return post("profiles", { type: "profile", attributes: { email: email, properties: clean(props) } });
  }
  function track(email, metric, props) {
    return post("events", { type: "event", attributes: { properties: clean(props || {}),
      metric: { data: { type: "metric", attributes: { name: metric } } },
      profile: { data: { type: "profile", attributes: { email: email } } } } });
  }
  function refillProps(rf, on) {
    return { hk_refill_opt_in: !!on, hk_last_scent: rf.scent, hk_refill_scents: rf.scents, hk_refill_pack: rf.pack, hk_refill_months: on ? rf.months : "", hk_refill_opt_in_at: on ? rf.at : "" };
  }
  /* o: { email, phone, sms (bool), emailConsent (default true), source, props } */
  function subscribe(o) {
    var email = String(o.email || "").trim();
    if (!okEmail(email)) return Promise.reject(new Error("email"));
    var subs = {}, attrs = { email: email };
    if (o.emailConsent !== false) subs.email = { marketing: { consent: "SUBSCRIBED" } };
    if (o.sms) {
      var ph = auMobile(o.phone); if (!ph) return Promise.reject(new Error("phone"));
      attrs.phone_number = ph; subs.sms = { marketing: { consent: "SUBSCRIBED" } };
    }
    attrs.subscriptions = subs;
    var data = { type: "subscription", attributes: { custom_source: o.source || "HomeKind site", profile: { data: { type: "profile", attributes: attrs } } } };
    if (LIST) data.relationships = { list: { data: { type: "list", id: LIST } } };
    return post("subscriptions", data).then(function () {
      remember(email);
      var p = o.props || {}, rf = pendingRefill();
      if (rf && rf.on) { var rp = refillProps(rf, true); for (var k in rp) p[k] = rp[k]; }
      if (o.source) p.hk_signup_source = o.source;
      return identify(email, p).then(function () {
        /* every chart request gets the chart email (Flow 1b), even for people already on the list */
        track(email, "HK Chart Requested", { source: o.source || "HomeKind site", page: location.pathname }).then(null, function () {});
        return true;
      }, function () { return true; });
    });
  }
  function bis(email, variantId) {
    email = String(email || "").trim();
    if (!okEmail(email)) return Promise.reject(new Error("email"));
    return post("back-in-stock-subscriptions", { type: "back-in-stock-subscription",
      attributes: { channels: ["EMAIL"], profile: { data: { type: "profile", attributes: { email: email } } } },
      relationships: { variant: { data: { type: "catalog-variant", id: "$shopify:::$default:::" + variantId } } } })
      .then(function () { remember(email); return true; });
  }
  /* on: ticked or not; info: { scent, scents, pack } */
  function refill(on, info) {
    info = info || {};
    var rec = { on: !!on, scent: info.scent || "", scents: info.scents || info.scent || "", pack: info.pack || 1, months: info.months || 3, at: new Date().toISOString(), page: location.pathname };
    ls("hk_refill", JSON.stringify(rec));
    var em = knownEmail(); if (!em) return Promise.resolve("cart attribute only");
    /* profile only: the reminder event comes from the paid order (referral service), so it
       fires once per order whether or not the site knew her email */
    return identify(em, refillProps(rec, on)).then(function () { return "profile"; });
  }

  /* ---------- forms ---------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function pdfLink(cls) { return PDF ? ' <a class="' + (cls || "link") + '" href="' + PDF + '" target="_blank" rel="noopener">Download the chart now (PDF)</a>' : ""; }
  function busy(btn, on, txt) { if (!btn) return; if (on) { btn.setAttribute("data-label", btn.textContent); btn.disabled = true; btn.setAttribute("aria-busy", "true"); btn.textContent = txt || "Sending"; } else { btn.disabled = false; btn.removeAttribute("aria-busy"); if (btn.getAttribute("data-label")) btn.textContent = btn.getAttribute("data-label"); } }
  function errIn(f, msg) {
    var e = $(".hk-klerr", f);
    if (!e) { e = document.createElement("p"); e.className = "hkv2-formerr hk-klerr"; e.setAttribute("role", "alert"); e.style.flexBasis = "100%"; f.insertBefore(e, f.firstChild); }
    e.textContent = msg;
  }
  function done(f, html) {
    var ok = document.createElement("p"); ok.className = "hkv2-formok hk-klok"; ok.setAttribute("role", "status"); ok.setAttribute("tabindex", "-1"); ok.style.flexBasis = "100%";
    ok.innerHTML = html; f.innerHTML = ""; f.appendChild(ok);
    try { ok.focus({ preventScroll: true }); } catch (x) { ok.focus(); }
  }
  function badEmail(ev, em) {
    if (!em) return true;
    ev.preventDefault(); em.setCustomValidity("Enter an email address like name@example.com"); em.reportValidity();
    em.addEventListener("input", function () { em.setCustomValidity(""); }, { once: true });
    return true;
  }
  document.addEventListener("submit", function (ev) {
    var f = ev.target; if (!f || !f.getAttribute || f.getAttribute("data-hk-native")) return;
    if (f.hasAttribute("data-hk-kl")) {
      var em = $('input[type="email"]', f);
      if (!em || !okEmail(em.value)) { badEmail(ev, em); return; }
      ev.preventDefault();
      var btn = $('[type="submit"]', f), tags = ($("[data-help-tags]", f) || {}).value || "";
      var quiz = tags.split(",").filter(function (t) { return t.indexOf("quiz-") === 0; }).map(function (t) { return t.slice(5); }).join(",");
      busy(btn, true);
      subscribe({ email: em.value, source: f.getAttribute("data-hk-kl"), props: { hk_signup_form: f.getAttribute("data-hk-form") || "", hk_quiz_answers: quiz } }).then(function () {
        done(f, (f.getAttribute("data-hk-ok") || "Done. Your chart is on its way by email.") + pdfLink(f.getAttribute("data-hk-linkcls") || "link"));
      }, function () {
        /* Klaviyo said no: keep the sign up by posting the normal Shopify form */
        f.setAttribute("data-hk-native", "1"); busy(btn, false);
        try { HTMLFormElement.prototype.submit.call(f); } catch (x) { errIn(f, "That did not go through. Please check your email and try again."); }
      });
      return;
    }
    if (f.hasAttribute("data-hk-bis")) {
      var be = $('input[type="email"]', f);
      if (!be || !okEmail(be.value)) { badEmail(ev, be); return; }
      ev.preventDefault();
      var ids = Array.prototype.slice.call(f.querySelectorAll('input[name="hk_bis"]:checked')).map(function (i) { return i.value; });
      if (!ids.length) { errIn(f, "Tick the scent you want to hear about."); return; }
      var bb = $('[type="submit"]', f); busy(bb, true);
      Promise.all(ids.map(function (id) { return bis(be.value, id); })).then(function () {
        done(f, "Done. We’ll email you once when it’s back.");
      }, function (e) {
        busy(bb, false);
        try { window.__hkBisErr = { status: e && e.status, body: e && e.body }; } catch (x) {}
        errIn(f, "That did not go through. Please check your email and try again.");
      });
    }
  }, true);

  window.HKKL = { subscribe: subscribe, identify: identify, track: track, bis: bis, refill: refill, auMobile: auMobile, okEmail: okEmail, known: knownEmail, pdf: PDF, VER: "2026-09-28-v25" };
})();
